var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-row justify-content-between pointer",
    on: {
      "click": _vm.logout
    }
  }, [_vm.logoutError ? _c('span', {
    staticClass: "logout-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.logoutError))]) : _vm._e(), _c('div', {
    staticClass: "p-relative mr-2"
  }, [_vm._m(0), _c('img', {
    staticClass: "broker-image",
    attrs: {
      "src": _vm.getProfileImage(),
      "width": "50",
      "alt": ""
    }
  })])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "settings-icon"
  }, [_c('img', {
    attrs: {
      "width": "12",
      "height": "12",
      "src": require("@/images/settings-icon.png"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }